import getMuiTheme from 'material-ui/styles/getMuiTheme'
import Theme from '../utils/theme'

/**
|--------------------------------------------------
| Constants
|--------------------------------------------------
*/
export const CHANGE_THEME = 'CHANGE_THEME'

/**
|--------------------------------------------------
| Actions
|--------------------------------------------------
*/
export const changeTheme = themeName => ({
  type: CHANGE_THEME,
  themeName
})

/**
|--------------------------------------------------
| Handlers
|--------------------------------------------------
*/
const ActionHandler = {
  [CHANGE_THEME]: (currentState, action) =>
    getMuiTheme({
      palette: Theme[action.themeName]
        ? { ...Theme[action.themeName] }
        : { ...Theme.SQC }
    })
}

/**
|--------------------------------------------------
| Reducer
|--------------------------------------------------
*/
const initialState = getMuiTheme({
  palette: {
    ...Theme.SQC
  }
})

export default function theme(currentState = { ...initialState }, action) {
  const handler = ActionHandler[action.type]
  const nextState = handler ? handler(currentState, action) : currentState
  return nextState
}



// WEBPACK FOOTER //
// ./src/store/theme.js